import { format } from 'date-fns'

/**
 * Cleans the input from react-input-emoji when image conversion is DISABLED.
 * Handles converting HTML newlines (<div>, <br>) into standard \n characters.
 */
export const cleanInputContent = (content: string): string => {
  if (!content) return "";

  let clean = content;

  // 1. Handle "Shift+Enter" or "Enter" artifacts
  // Libraries often wrap lines in <div>...</div>. We want to turn the START of a div into a newline.
  clean = clean.replace(/<div>/gi, '\n');
  
  // 2. Remove the closing </div> (we already added the newline at the start)
  clean = clean.replace(/<\/div>/gi, '');

  // 3. Convert explicit <br> tags to newlines
  clean = clean.replace(/<\/?br\s*\/?>/gi, '\n');

  // 4. Decode HTML entities (e.g., &nbsp; -> space, &lt; -> <)
  // This is important because contentEditable often turns spaces into &nbsp;
  const txt = document.createElement("textarea");
  txt.innerHTML = clean;
  clean = txt.value;

  // 5. Trim extra whitespace from start/end (but keep internal newlines)
  return clean.trim();
};

export const isPhoneNumber = (name: string) => {
  // Regex matches if string starts with +, or contains only digits/dashes/spaces
  return /^[\d\s\+\-]+$/.test(name);
};

// Helper function to format status text with spaces instead of underscores and capitalize words
export const formatStatusText = (status: string): string => {
  if (status === 'partially_completed') return 'Pending Retry'
  return status.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
};

// Helper function to convert 24-hour time to 12-hour format
export const formatTime12Hour = (time24: string): string => {
  if (!time24) return ''
  const [hours, minutes] = time24.split(':').map(Number)
  const date = new Date()
  date.setHours(hours, minutes, 0)
  return format(date, 'h:mm a')
};

// Helper function to format date string for datetime-local input field
// Converts date string to YYYY-MM-DDTHH:mm format in browser's local timezone
export const formatDateForInput = (dateString: string): string => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return format(date, "yyyy-MM-dd'T'HH:mm")
};

// Helper function to format time string for time input field (HH:mm)
export const formatTimeForInput = (time: any): string => {
  if (!time) return '09:00'
  if (typeof time === 'string') {
    // If it's already in HH:mm format, return it
    if (time.match(/^\d{2}:\d{2}$/)) return time
    // If it's in HH:mm:ss format, extract HH:mm
    if (time.match(/^\d{2}:\d{2}:\d{2}$/)) return time.substring(0, 5)
  }
  return '09:00'
};